module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/Icon/twitter-91dba9f8657cff265371d50de266460a.svg";